import React from 'react';

const EstadoBloqueadoInactividad = (props) => {
    return (
        <div className="dropdown state pull-right" id={"state-block-" + props.ID}>
            <button type="button" data-toggle="dropdown" data-target={"#state-block-" + props.ID}
                className="btn btn-cta btn-sm btn-blocked">BLOQUEADO</button>
            <ul className="dropdown-menu">
                <li className="bottom-separator-xs">
                    <p className="state-break"><i>{"Usuario bloqueado por Inactividad"}</i></p>                                        
                </li>
            </ul>
        </div>
    );
}

export default EstadoBloqueadoInactividad;
